import React from "react";
import Shell from "../components/Shell";
import CalendarWidget from "../components/CalendarWidget";

/**
 * Dedicated Calendar workspace — surfaces the same widget used inside the
 * Command Center, but at full-page scale and without any of the editing /
 * hide / collapse chrome. Reachable from the left rail via `nav-calendar`.
 */
export default function CalendarPage() {
  return (
    <Shell>
      <div className="p-6 md:p-8">
        <div className="mb-6">
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-faint mb-2">
            WORKSPACE / CALENDAR
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight leading-none text-aurora">
            Calendar
          </h1>
          <p className="mt-2 text-sm text-muted">
            Everything with a date — events, tasks, rehearsals, run-of-show blocks, and your own custom entries — on one grid.
          </p>
        </div>

        <div data-testid="calendar-page-widget">
          <CalendarWidget />
        </div>
      </div>
    </Shell>
  );
}
